import React, { useState } from 'react';
import './App.css'
import SearchBar from '../SearchBar/SearchBar';
import SearchResults from '../SearchResults/SearchResults';
import Playlist from '../Playlist/Playlist';
import Spotify from '../../utils/Spotify';

function App(props) {
  const [searchResults, setSearchResults] = useState([])
  const [playlistName, setPlaylistName] = useState('Summer Bangers')
  const [playlistTracks, setPlaylistTracks] = useState([])

  const addTrack = (track) => {
    if (playlistTracks.find(savedTrack => savedTrack.id === track.id)) {
      return;
    }
  
    const newPlaylistTracks = [...playlistTracks, track]; // Create a new array with the modified tracks
    setPlaylistTracks(newPlaylistTracks);
  }

  const removeTrack =(track) => {
    const updatedTracks = playlistTracks.filter(currentTrack => currentTrack !== track)
    setPlaylistTracks(updatedTracks)
  }

  const updatePlaylistName = (name) => {
    setPlaylistName(name)
  }

  const savePlaylist = () => {
    const trackUris = playlistTracks.map(track => track.uri)
    Spotify.savedPlaylist(playlistName, trackUris).then(() => {
      setPlaylistName('New Playlist')
      setPlaylistTracks([])
    })
  }

  const search = term => {
    Spotify.search(term).then(searchResults => setSearchResults(searchResults))
  }

  return (
    <div>
  <h1>Ja<span className="highlight">mmm</span>ing</h1>
  <div className="App">
    
    <SearchBar onSearch={search} />
    <div className="App-playlist">
      
      <SearchResults searchResults={searchResults} onAdd={addTrack} />
      
      <Playlist playlistName={playlistName} playlistTracks={playlistTracks} onRemove={removeTrack} onNameChange={updatePlaylistName} onSave={savePlaylist} />
    </div>
  </div>
</div>
  );
}

export default App;
